export function svgTemplateToIcon(id) {
    return 'data:image/svg+xml;base64,' + btoa(document.getElementById(id).innerHTML)
}